import React, { useEffect, useState } from 'react';
import { all_routes } from '../../../../core/data/routes/all_routes';
import { Link } from 'react-router-dom';
// import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { auth, db } from '../../../../firebase';
import { getDocs, collection, limit, query } from 'firebase/firestore';
import { Spin } from 'antd';
import { useNavigate } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';

const FeatureSection = () => {

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue1, setSelectedValue1] = useState(null);
  const [selectedItems, setSelectedItems] = useState(Array(13).fill(false));
  const [user, authLoading] = useAuthState(auth); // Firebase user auth

  // Fetch categories from Firestore

  // Fetch categories from Firestore

  // const [selectedItems, setSelectedItems] = useState(Array(13).fill(false));

  const navigate = useNavigate();
  const routes = all_routes;

  // Fetch categories from Firestore
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const collectionName = user ? "categories" : "categories_duplicate";
      const q = query(collection(db, collectionName), limit(8));
      const categoriesSnapshot = await getDocs(q);
      const categoriesList = categoriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoriesList);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

// Wait until auth is fully loaded before fetching
useEffect(() => {
  if (!authLoading) {
    fetchCategories();
  }
}, [authLoading, user]);


  const handleItemClick = (index) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = [...prevSelectedItems];
      updatedSelectedItems[index] = !updatedSelectedItems[index];
      return updatedSelectedItems;
    });
  };

  // Navigate to Service Details Page with Category Data
  const handleBookNow = (category) => {
    console.log("testing")
    navigate(routes.serviceDetails1, { state: { category } });
  };


  return (
    <>
      {/* Service Section */}
      <section className="section service-section"
        style={{
          backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
              <div className="section-header text-center">
                <h2 className="mb-1" style={{ color: '#fff' }}>
                  Our Featured <span className="text-linear-primary">Categories</span>
                </h2>
                <p className="sub-title" style={{ color: '#fff' }}>
                  Each listing is designed to be clear and concise, providing customers
                </p>
              </div>
            </div>
          </div>
          {/* Categories List */}
          <div className="row">
            {loading ? (
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <div className="card p-0">
                    <div className="card-body p-0">
                      <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <Spin />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <div className="card p-0">
                    <div className="card-body p-0">
                      <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <Spin />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <div className="card p-0">
                    <div className="card-body p-0">
                      <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <Spin />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <div className="card p-0">
                    <div className="card-body p-0">
                      <div className="img-sec w-100 d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <Spin />
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            ) : (
              categories.map((category, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={category.id}>
                  <div className="card p-0" style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "15px",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    borderColor: "#ffffff00",
                    color: "#fff",
                  }}>
                    <div className="card-body p-0" onClick={() => handleBookNow(category)}>
                      <div className="img-sec w-100">
                        <img
                          src={category.category_view_icon || "placeholder-image-path.jpg"}
                          className="img-fluid rounded-top w-100"
                          alt="Category"
                        />
                        <div className="image-tag d-flex justify-content-end align-items-center">
                          <span className="trend-tag">
                            {category.main_type || "Untitled Category"}
                          </span>
                          <button
                            onClick={() => handleItemClick(index)}
                            className={`fav-icon like-icon ${selectedItems[index] ? "selected" : ""}`}
                          >
                            <i className="ti ti-heart" />
                          </button>
                        </div>
                        <span className="image-logo avatar avatar-md border rounded-circle">
                          <img
                            src={category.icon || "placeholder-image-path.jpg"}
                            className="img-fluid rounded-circle"
                            alt="Logo"
                          />
                        </span>
                      </div>
                      <div className="p-3">
                        <h5 className="mb-2" style={{color: '#fff'}}>{category.title || "Untitled Category"}</h5>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="rating text-gray fs-14">
                            <i className="fa fa-star filled me-1" /> 4.9
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 style={{color: '#fff'}}>₹ {category.price ? category.price.toFixed(2) : "Price not available"}</h5>
                          <button
                            // onClick={() => handleBookNow(category)}
                            className="btn bg-primary-transparent">
                            Book Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              ))
            )}
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
                <Link to={all_routes.serviceGrid} className="btn btn-dark">
                  View All
                  <i className="ti ti-arrow-right ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Service Section */}
    </>
  );
};

export default FeatureSection;
